import { FastField, getIn, useFormikContext } from "formik";
import React, { useEffect, useRef } from "react";
import { theme } from "../../../Customization/Theme";
import {
  StyledInputField,
  StyledWidgetInputBox,
} from "../../Styles/StyledForms";
import { useAppSelector } from "../../../Store";

import { allMessagesStore } from "../../../Store/Slices/socket/AllMessagesSlice";
import AppErrorMessage from "./AppErrorMessage";
import AppSendSubmitButton from "./AppSendSubmitButton";
import AppVoiceButton from "./AppVoiceButton";

interface Props {
  name?: string;
  label?: string;
  children?: React.ReactNode;
  showVoiceButton?: boolean;
  [otherProps: string]: any;
  ref?: any;
}

const AppFlowNumberField: React.FC<Props> = ({
  name = "number",
  label = "18",
  children,
  showVoiceButton = false,
  ...otherProps
}) => {
  const { errors, touched, values, handleChange, setFieldValue, handleSubmit, setFieldError } = useFormikContext<any>();
  const { typingStatus } = useAppSelector(allMessagesStore);

  const handleVoiceInput = (text: string) => {
    // Extract numeric values from voice input
    const numericMatch = text.match(/\d+(?:\.\d+)?/);
    
    if (numericMatch) {
      // If numeric value found, use it
      const numericValue = numericMatch[0];
      setFieldValue(name, numericValue);
      // Automatically submit the form after voice input
      setTimeout(() => {
        handleSubmit();
      }, 100);
    } else {
      // If no numeric value found, show error and don't submit
      setFieldError(name, "Only numbers are allowed.");
      setFieldValue(name, "");
    }
  };

  return (
    <StyledWidgetInputBox
      disabled={typingStatus ? true : false}
      error={getIn(errors, name) && getIn(touched, name)}
    >
      <FastField name={name}>
        {({ field }: any) => (
          <StyledInputField
            {...otherProps}
            {...field}
            value={getIn(values, name) || ""}
            onChange={(e: any) => {
              // Allow only numbers and decimal points
              const value = e.target.value;
              const regex = /^[0-9]*\.?[0-9]*$/;
              if (value === "" || regex.test(value)) {
                handleChange(e);
              }
            }}
            placeholder={label}
            type={"text"}
            autoFocus={true}
          />
        )}
      </FastField>

      {showVoiceButton ? (
          getIn(values, name)?.length > 0 ? (
            <AppSendSubmitButton />
          ) : (
            <AppVoiceButton onVoiceInput={handleVoiceInput} />
          )
        ) : (
          <AppSendSubmitButton />
        )}

      <AppErrorMessage
        error={getIn(errors, name)}
        visible={getIn(touched, name)}
      />
    </StyledWidgetInputBox>
  );
};

export default AppFlowNumberField;
